var _path, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValue03(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0714 85C58.3395 85 54.4437 88.7202 54.2255 93.447L54.2062 93.8654C54.1716 94.6161 54.0064 95.3549 53.7182 96.0489C53.6009 96.3312 53.5052 96.6153 53.4299 96.8999H48.4C45.4177 96.8999 43 99.3176 43 102.3C43 105.282 45.4177 107.7 48.4 107.7H88C90.9823 107.7 93.4 105.282 93.4 102.3C93.4 99.3176 90.9823 96.8999 88 96.8999H82.9557C82.8933 96.6355 82.8139 96.3709 82.7166 96.1073C82.4461 95.3749 82.3077 94.6003 82.3077 93.8196V93.4838C82.3077 88.7983 78.5094 85 73.8239 85H63.0714Z",
    fill: "url(#paint0_linear_603_1261)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_603_1261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 31,
    width: 81,
    height: 58.5,
    rx: 5,
    fill: "url(#paint1_linear_603_1261)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_603_1261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22,
    width: 81,
    height: 58.5,
    rx: 5,
    fill: "url(#paint2_linear_603_1261)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 22.5,
    width: 80,
    height: 57.5,
    rx: 4.5,
    stroke: "url(#paint3_linear_603_1261)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_603_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9765 32.7004C72.799 32.6896 73.5241 33.2378 73.7381 34.032L78.7955 52.8065L79.605 50.7811C79.8782 50.0975 80.5402 49.6492 81.2764 49.6492H90C90.9941 49.6492 91.8 50.4551 91.8 51.4492C91.8 52.4433 90.9941 53.2492 90 53.2492H82.4954L80.1338 59.158C79.8462 59.8775 79.1305 60.3322 78.357 60.2869C77.5835 60.2416 76.9258 59.7063 76.7243 58.9582L72.0951 41.7734L66.1417 66.4228C65.9631 67.1621 65.3392 67.7093 64.583 67.79C63.8267 67.8707 63.1014 67.4674 62.7709 66.7825L55.0489 50.7796L51.3573 57.9095C51.0528 58.4975 50.4501 58.8709 49.788 58.8816C49.1259 58.8923 48.5114 58.5386 48.188 57.9608L41.8794 46.6864L35.5708 57.9608C35.0854 58.8283 33.9886 59.1381 33.1211 58.6526C32.2535 58.1672 31.9438 57.0704 32.4292 56.2029L40.3086 42.1212C40.6269 41.5525 41.2277 41.2002 41.8794 41.2002C42.5312 41.2002 43.132 41.5525 43.4502 42.1212L49.6973 53.2857L53.5071 45.9277C53.8206 45.3222 54.4492 44.9459 55.1309 44.9555C55.8126 44.9651 56.4304 45.359 56.7267 45.973L63.8246 60.6825L70.2503 34.0776C70.4435 33.278 71.154 32.7111 71.9765 32.7004Z",
    fill: "url(#paint4_linear_603_1261)",
    shapeRendering: "geometricPrecision"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_603_1261",
    x: 26,
    y: 31,
    width: 89,
    height: 66.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.415686 0 0 0 0 0.270588 0 0 0 0 0.937255 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_603_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_603_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_603_1261",
    x: 16,
    y: 18,
    width: 89,
    height: 66.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_603_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_603_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_603_1261",
    x: 28.1997,
    y: 32.7002,
    width: 67.6003,
    height: 43.1001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.219608 0 0 0 0 0.898039 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_603_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_603_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_603_1261",
    x1: 68,
    y1: 85,
    x2: 68,
    y2: 105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_603_1261",
    x1: 68.5,
    y1: 31,
    x2: 68.5,
    y2: 89.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A56FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6641EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_603_1261",
    x1: 60.5,
    y1: 22,
    x2: 60.5,
    y2: 80.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_603_1261",
    x1: 101,
    y1: 78.738,
    x2: 31.2033,
    y2: -12.2575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416667,
    stopColor: "#BCABF7",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E86F4",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_603_1261",
    x1: 62,
    y1: 43.0002,
    x2: 62,
    y2: 66.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue03);
export default __webpack_public_path__ + "static/media/value-03.80a0e4aebb9bfba3476fad5148a3ca8b.svg";
export { ForwardRef as ReactComponent };